const JOURNEY_KEY = "od_pre_account_journey";
const ASSESSMENT_KEY = "od_latest_eligibility_result";
const DISMISS_KEY = "od_transfer_prompt_dismissed";

export const loadJourneySession = () => {
  try {
    return JSON.parse(window.sessionStorage.getItem(JOURNEY_KEY) || "{}");
  } catch {
    return {};
  }
};

export const saveJourneySession = (answers) => {
  window.sessionStorage.setItem(JOURNEY_KEY, JSON.stringify(answers || {}));
};

export const clearJourneySession = () => {
  window.sessionStorage.removeItem(JOURNEY_KEY);
  window.sessionStorage.removeItem(ASSESSMENT_KEY);
  window.sessionStorage.removeItem(DISMISS_KEY);
};

export const saveLatestEligibilityResult = (result) => {
  window.sessionStorage.setItem(ASSESSMENT_KEY, JSON.stringify(result || null));
};

export const loadLatestEligibilityResult = () => {
  try {
    return JSON.parse(window.sessionStorage.getItem(ASSESSMENT_KEY) || "null");
  } catch {
    return null;
  }
};

export const dismissTransferPrompt = () => window.sessionStorage.setItem(DISMISS_KEY, "1");
export const transferPromptDismissed = () => window.sessionStorage.getItem(DISMISS_KEY) === "1";

export const journeySummaryLabels = {
  funding_intention: "Funding intention",
  current_location: "Current location",
  uk_status: "UK status",
  subject_interest: "Subject interest",
};
